export default "__VITE_ASSET__DsqjNuo4__"